<!-- Displays the fahrt start times horizontally. Clicks delegate an event to the parent -->
<template>
  <div class="d-flex" v-if="rows && rows.length > 0">
    <v-btn fab small color="primary" @click.prevent="scrollTimelineToLeft" class="fab-btn">
      <v-icon small>mdi-arrow-collapse-left</v-icon>
    </v-btn>

    <div class="timeline hide-scrollbar">
      <div class="d-flex flex-row flex-no-wrap mb-2">
        <div class="d-flex" v-for="(verlauf, index) in verlaeufe" :key="index">
          <div
            :id="`btn_${verlauf.rowId}`"
            :style="`padding-left:10px !important;padding-right:10px !important;margin-right: 1px;${
              verlauf.rowId === selectedVerlaufRowId ? '' : 'background:#a0a0a0'
            }`"
            :class="`time-box time ${xs ? '' : 'px-1'} ${verlauf.rowId === selectedVerlaufRowId ? 'primary white--text' : ''}`"
            @click.prevent="onSelected(verlauf)"
          >
            {{ verlauf.abFormatted ? verlauf.abFormatted : '' }}
          </div>
          <div v-if="index < verlaeufe.length - 1" class="connector" :class="theme.bottomNav.bg"></div>
        </div>
      </div>
    </div>
    <v-btn color="primary" fab small @click.prevent="scrollTimelineToRight" class="ml-1 fab-btn">
      <v-icon small>mdi-arrow-collapse-right</v-icon>
    </v-btn>
  </div>
</template>

<script>
import common from '@/mixins/common';
import dateTimeMixin from '@/mixins/dateTimeMixin';
import { delay } from '../../common/utils';

export default {
  name: 'HorizontalTimeline',
  mixins: [common, dateTimeMixin],
  props: {
    rows: Array, // fahrt items
    selectedRowIndex: Number, // index of the selected fahrt (in relation to fahrtTimes)
    dateString: String,
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      selectedVerlaufRowId: null,
    };
  },
  computed: {
    verlaeufe() {
      return this.rows ? this.rows.filter((i) => i.isFirstOfVerlauf) : [];
    },
  },
  methods: {
    init() {
      if (!this.selectedVerlaufRowId) {
        let verlaufRowId;
        if (this.rows && this.rows.length > 0 && this.selectedRowIndex !== undefined) {
          let i = this.selectedRowIndex;
          while (i >= 0) {
            if (this.rows[i].isFirstOfVerlauf) {
              verlaufRowId = this.rows[i].rowId;
              break;
            }
            i--;
          }
        }
        console.debug('verlaufRowId selected', verlaufRowId);
        this.selectedVerlaufRowId = verlaufRowId;
      }
    },
    onSelected(verlauf) {
      this.selectedVerlaufRowId = verlauf.rowId;
      this.$emit('scrollToItemWithId', verlauf.rowId);
      setTimeout(() => (this.selectedVerlaufRowId = null), 2000);
    },
    async scrollTimelineToLeft() {
      let firstRowId = this.verlaeufe[0].rowId;
      let el = document.getElementById(`btn_${firstRowId}`);
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      await delay(1000);
      this.$emit('scrollToItemWithId', firstRowId);
    },
    async scrollTimelineToRight() {
      let lastRowId = this.verlaeufe[this.verlaeufe.length - 1].rowId;
      let el = document.getElementById(`btn_${lastRowId}`);
      el.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      await delay(1000);
      this.$emit('scrollToItemWithId', lastRowId);
    },
    time(minutesAfterMidnight) {
      return this.getTimeFromMinutesAfterMidnight(this.configuredTimeFormat, minutesAfterMidnight, this.dateString);
    },
  },
  watch: {
    selectedRowIndex(newValue, oldValue) {
      this.init();
    },
  },
};
</script>

<style lang="scss" scoped>
@import './perlschnur.scss';
</style>
<style scoped>
.timeline {
  overflow-x: scroll;
}
.fab-btn {
  margin-top: -5px;
  margin-right: 5px;
}
.time-box {
  border-radius: 20px;
  font-size: 0.8em;
}
.connector {
  width: 10px;
  height: 4px;
  margin-left: -2px;
  margin-top: 14px;
}
</style>
